export enum ProjectIcon {
    certificate = 'certificate',
    certificateSelectedItems = 'certificate-selected-items',
    calendarCheck = 'calendar-check'
}
